import {
    patchCustomerProfileDetailsUpdateMobileReducer,
} from '../../slices/gq-customer/customer-profile';

export const gqCustomerProfileReducers = {
    patchCustomerProfileDetailsUpdateMobile: patchCustomerProfileDetailsUpdateMobileReducer,
};
